// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import DatePicker from "react-multi-date-picker";
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
// import axiosInstance from '../utils/axiosInstance';

// const LetterInterface = () => {
//   const [title, setTitle] = useState('');
//   const [body, setBody] = useState('');
//   const [from, setFrom] = useState('');
//   const [to, setTo] = useState('');
//   const [date, setDate] = useState(null);
//   const [template, setTemplate] = useState('1');
//   const [fileType, setFileType] = useState('pdf');
//   const [templateOptions, setTemplateOptions] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchTemplates = async () => {
//       try {
//         const response = await axiosInstance.get('/documents/letter-templates/options/');
//         setTemplateOptions(response.data.templates);
//       } catch (err) {
//         setError('خطا در بارگذاری قالب‌ها');
//       }
//     };
//     fetchTemplates();
//   }, []);

//   const handleDateChange = (dateObject) => {
//     setDate(dateObject);
//   };

//   const handleSubmit = async () => {
//     if (!title || !body || !date || !from || !to) {
//       setError('لطفاً تمام فیلدها را پر کنید.');
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     const formattedDate = `${date.format('YYYY/MM/DD')}`;
//     const filename = `${title.replace(/\s+/g, '-')}.${fileType}`;

//     const payload = {
//       template_id: parseInt(template) || 1,
//       date: formattedDate,
//       title: title,
//       text: body,
//       from_text: from,
//       to_text: to,
//       is_plain_text: true,
//       align: "justify",
//       leading: 16,
//       filename: filename,
//       file_type: fileType || 'pdf'
//     };

//     try {
//       await axiosInstance.post('/documents/letters/', payload, {
//         responseType: 'blob',
//       });
//       setTitle('');
//       setBody('');
//       setFrom('');
//       setTo('');
//       setDate(null);
//       setTemplate('1');
//       setFileType('pdf');
//       navigate('/LetterList');
//     } catch (err) {
//       setError(err.message || 'خطا در ارسال درخواست');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="dir-rtl text-right p-6 max-w-2xl mx-auto mt-28 bg-white shadow-lg rounded-lg">
//       <h2 className="text-2xl font-semibold mb-6 text-gray-800">ایجاد نامه رسمی</h2>
      
//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="from" className="block mb-2 text-sm font-medium text-gray-700">از:</label>
//         <input
//           id="from"
//           type="text"
//           value={from}
//           onChange={(e) => setFrom(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           placeholder="نام فرستنده را وارد کنید"
//         />
//       </div>

//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="to" className="block mb-2 text-sm font-medium text-gray-700">به:</label>
//         <input
//           id="to"
//           type="text"
//           value={to}
//           onChange={(e) => setTo(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           placeholder="نام گیرنده را وارد کنید"
//         />
//       </div>

//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-700">عنوان نامه:</label>
//         <input
//           id="title"
//           type="text"
//           value={title}
//           onChange={(e) => setTitle(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           placeholder="عنوان نامه را وارد کنید"
//         />
//       </div>
      
//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="body" className="block mb-2 text-sm font-medium text-gray-700">متن نامه:</label>
//         <textarea
//           id="body"
//           value={body}
//           onChange={(e) => setBody(e.target.value)}
//           rows={8}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           placeholder="متن نامه را وارد کنید"
//         />
//       </div>
      
//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="template" className="block mb-2 text-sm font-medium text-gray-700">قالب نامه:</label>
//         <select
//           id="template"
//           value={template}
//           onChange={(e) => setTemplate(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="1">قالب پیش‌فرض</option>
//           {templateOptions.map((option) => (
//             <option key={option.id} value={option.id}>{option.name}</option>
//           ))}
//         </select>
//       </div>
      
//       <div className="mb-5" dir='rtl'>
//         <label htmlFor="fileType" className="block mb-2 text-sm font-medium text-gray-700">نوع فایل:</label>
//         <select
//           id="fileType"
//           value={fileType}
//           onChange={(e) => setFileType(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="pdf">PDF</option>
//           <option value="docx">DOCX</option>
//         </select>
//       </div>
      
//       <div className="mb-5">
//         <label className="block mb-2 ml-4 text-xl font-medium text-gray-700">تاریخ:</label>
//         <DatePicker
//           style={{
//             padding: '12px',
//             width: '100%',
//             border: '1px solid #d1d5db',
//             borderRadius: '0.375rem',
//             fontSize: '0.875rem',
//             direction: 'rtl'
//           }}
//           value={date}
//           onChange={handleDateChange}
//           calendar={persian}
//           locale={persian_fa}
//           format="YYYY/MM/DD"
//           numerals="en"
//           placeholder="برای انتخاب تاریخ کلیک کنید"
//           className="date-picker"
//           clearable
//         />
//       </div>
      
//       {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      
//       <div className="flex-col justify-end">
//         <button 
//           onClick={handleSubmit} 
//           disabled={loading}
//           className="bg-blue-600 text-white min-w-full px-5 py-2.5 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
//         >
//           {loading ? 'در حال پردازش...' : 'ایجاد نامه'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LetterInterface;


import React, { useState } from 'react';
import toast from "react-hot-toast";
import { getApiErrorLines } from "../utils/formErrors";
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import axiosInstance from '../utils/axiosInstance';

const LetterInterface = () => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [docNum, setDocNum] = useState('');
  const [date, setDate] = useState(null);
  const [fileType, setFileType] = useState('pdf');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDateChange = (dateObject) => {
    setDate(dateObject);
  };

  const handleSubmit = async () => {
    if (!body || !date) {
      setError('لطفاً متن نامه و تاریخ را پر کنید.');
      toast.error('لطفاً متن نامه و تاریخ را پر کنید.');
      return;
    }

    setLoading(true);
    setError(null);

    const formattedDate = `${date.format('YYYY/MM/DD')}`;
    const filename = `${(title || 'letter').replace(/\s+/g, '-')}.${fileType}`;

    const payload = {
      template_id: 1,
      date: formattedDate,
      title: title || 'بدون عنوان',
      text: body,
      from_text: from || 'بدون فرستنده',
      to_text: to || 'بدون گیرنده',
      doc_number: docNum,
      is_plain_text: true,
      align: "justify",
      leading: 16,
      filename: filename,
      file_type: fileType || 'pdf'
    };

    try {
      await axiosInstance.post('/documents/letters/', payload, {
        responseType: 'blob',
      });
      setTitle('');
      setBody('');
      setFrom('');
      setTo('');
      setDocNum('');
      setDate(null);
      setFileType('pdf');
      navigate('/LetterList');
    } catch (err) {
      const message = getApiErrorLines(err, {}, 'خطا در ارسال درخواست').join(' ');
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dir-rtl text-right p-6 max-w-2xl mx-auto mt-28 bg-white shadow-lg rounded-lg pb-10">
      <h2 className="text-2xl font-semibold mb-6 text-gray-800">ایجاد نامه رسمی</h2>
      
      <div className="mb-5" dir='rtl'>
        <label htmlFor="from" className="block mb-2 text-sm font-medium text-gray-700">فرستنده (اختیاری):</label>
        <input
          id="from"
          type="text"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="نام و نام خانوادگی فرستنده"
        />
      </div>

      <div className="mb-5" dir='rtl'>
        <label htmlFor="to" className="block mb-2 text-sm font-medium text-gray-700">گیرنده (اختیاری):</label>
        <input
          id="to"
          type="text"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="نام و نام خانوادگی گیرنده"
        />
      </div>

      <div className="mb-5" dir='rtl'>
        <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-700">موضوع (اختیاری):</label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="موضوع نامه"
        />
      </div>

      <div className="mb-5" dir='rtl'>
        <label htmlFor="docNum" className="block mb-2 text-sm font-medium text-gray-700">شماره نامه (اختیاری):</label>
        <input
          id="docNum"
          type="text"
          value={docNum}
          onChange={(e) => setDocNum(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="شماره نامه را وارد کنید"
        />
      </div>
      
      <div className="mb-5" dir='rtl'>
        <label htmlFor="body" className="block mb-2 text-sm font-medium text-gray-700">متن نامه:</label>
        <textarea
          id="body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          rows={8}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="متن نامه را وارد کنید"
        />
      </div>
      
      <div className="mb-5">
        <label className="block mb-2 ml-4 text-xl font-medium text-gray-700">تاریخ:</label>
        <DatePicker
          style={{
            padding: '12px',
            width: '100%',
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            fontSize: '0.875rem',
            direction: 'rtl'
          }}
          value={date}
          onChange={handleDateChange}
          calendar={persian}
          locale={persian_fa}
          format="YYYY/MM/DD"
          numerals="en"
          placeholder="برای انتخاب تاریخ کلیک کنید"
          className="date-picker"
          clearable
        />
      </div>
      
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      
      <div className="flex-col justify-end">
        <button 
          onClick={handleSubmit} 
          disabled={loading}
          className="bg-blue-600 text-white min-w-full px-5 py-2.5 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? 'در حال پردازش...' : 'ایجاد نامه'}
        </button>
      </div>
    </div>
  );
};

export default LetterInterface;
